"use strict";
window._theme = window._theme || {};

_theme.initSlickSlider = function(selector, settings, initCallBack, afterChangeCallBack, beforeChangeCallback){
  if(!selector || !settings) return;
  let $productGrid = selector;
  if(typeof selector === 'string'){
    $productGrid = $(selector);
  }
  if(typeof selector === "object" && !$productGrid.hasOwnProperty('length')){
    $productGrid = $(selector);
  }

  if($productGrid.length === 0) return;

  if($productGrid.hasClass('slick-initialized')){
    $productGrid.slick('unslick');
  }

  $productGrid.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    slickCB(slick);
    setTimeout(function(){
      slickCB(slick);
    }, 1000);
    if(beforeChangeCallback && typeof beforeChangeCallback === 'function') beforeChangeCallback(slick);
  });

  $productGrid.on('afterChange', function(event, slick, currentSlide, nextSlide){
    slickCB(slick);
    setTimeout(function(){
      slickCB(slick);
    }, 1000);

    if(afterChangeCallBack && typeof afterChangeCallBack === 'function') afterChangeCallBack(slick);
  });

  $productGrid.on('init', function(event, slick, currentSlide, nextSlide){
    slickCB(slick);
    setTimeout(function(){
      slickCB(slick);
    }, 1000);

    var slickReviewInterval = setInterval(function () {
      if($('.yotpo-bottomline.pull-left.star-clickable').is(':visible')){
        slick.$slider.find('.slick-slide:not(.slick-active)').find('.yotpo-bottomline.pull-left.star-clickable').removeAttr("tabindex aria-hidden");
        slick.$slider.find('.slick-slide:not(.slick-active)').find('.yotpo-bottomline .sr-only').removeAttr("tabindex");
        slick.$slider.find('.slick-slide:not(.slick-active)').find('.yotpo-bottomline.yotpo-small').removeAttr("tabindex aria-hidden");
        clearInterval(slickReviewInterval);
      }; 
      if($('.yotpo-bottomline').length) {   
        slick.$slider.find('.yotpo.bottomLine').find('.sr-only').each(function() { 
          let review=$(this).text()+' out of 5';
          if(!$(this).closest('.product-details').find('[data-show-star]').length) {
            $(this).closest('.product-details').prepend('<p class="visually-hidden" data-show-star>'+ review +'</p>');     
          }
        });
      }
    }, 1000);
    setTimeout(function() {
      clearInterval(slickReviewInterval);
    },10000)

    if(initCallBack && typeof initCallBack === 'function') initCallBack(slick);
  });

  $productGrid.slick(settings);

  function slickCB(slick){
    const tabbableElems = ['select', 'input', 'textarea', 'button', 'a', 'iframe'];
    slick.$slider.find('.slick-slide').removeAttr('tabindex aria-hidden');
    slick.$slider.find('.slick-slide:not(.slick-active)').attr({
      "tabindex": -1,
      "aria-hidden": true
    });
    
    tabbableElems.forEach(function(item){
      slick.$slider.find('.slick-slide:not(.slick-active)').find(item).attr({
        "tabindex": -1,
        "aria-hidden": true
      });
      
      slick.$slider.find('.slick-slide.slick-active').find(item).each(function(index, item){
        if(!$(this).hasClass('text-m')) $(this).removeAttr('tabindex aria-hidden');
      });
    });
    
    slick.$slider.find( ".yotpo-bottomline .yotpo-stars" ).each(function( index ) {
      if($(this).attr("role") != "img") {
        $(this).attr("role","img");
        $(this).parent('.yotpo-bottomline').find('.text-m').attr('tabindex','-1');
        $(this).attr("aria-label",$(this).parent('.yotpo-bottomline').find('.yotpo-stars .sr-only').text()+' based on '+$(this).parent('.yotpo-bottomline').find('.text-m').text());
        $(this).parent('.yotpo-bottomline').removeAttr('tabindex');
      }
    });

    slick.$slider.find('.slick-slide:not(.slick-current)').find('.yotpo-bottomline').attr('tabindex', -1);
    slick.$slider.find('.slick-slide').find('.yotpo-icon.yotpo-icon-star').attr({'tabindex':'-1','aria-hidden':'true'}); 
    // slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
    // slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide').find('.yotpo-bottomline').attr({'tabindex':'-1'});
    slick.$slider.find('.slick-slide').find('.yotpo-bottomline .text-m').attr({'tabindex':'-1'});
    slick.$slider.find('.slick-slide.slick-active').find('.yotpo-bottomline').attr({'tabindex':'0'});
    $('.yotpo-bottomline .text-m').attr('tabindex','-1');
    $('.slick-slide .flickity-slider .gallery-cell').find('img').removeAttr("tabindex");
  }
}


_theme.isMobile = window.innerWidth < 768 ? true : false;


class TabsAutomatic {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1; 
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
        var currentTabId = tab.getAttribute('aria-controls');
        if($('#'+currentTabId+' .tab-slider').length > 0) {
          $('#'+currentTabId+' .tab-slider > .one-whole > .product-list').slick('refresh');
        }
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

_theme.ProductPage = function(){
  var PDPTabLists = document.querySelectorAll('[role=tablist].automatic');
  for (var i = 0; i < PDPTabLists.length; i++) {
    new TabsAutomatic(PDPTabLists[i]);
  }
}

_theme.Account = function(){
  $('[data-view-pswd]').click(function(e){
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault(); 
    console.log("show evebt:",e)
    const $pswdInput = $(this).parent().find('input');
    const type = $pswdInput.attr('type');
    if(type === 'password') {
      $pswdInput.attr('type', 'text');
      $(this).attr('aria-label','Hide Password');
      $(this).addClass('password-visible');
    } else {
      $pswdInput.attr('type', 'password');
      $(this).attr('aria-label','Show Password');
      $(this).removeClass('password-visible');
    }
  });
}

_theme.sealSubscriptionlogin = function(){
  if(location.pathname.indexOf('/a/subscriptions/login') === -1) return;
  const heading = document.querySelector('[data-seal-form] > h2');
  const emailInput = document.querySelector('[data-seal-form] input[name="customer_email"]');
  const sendLinkBtn = document.querySelector('[data-seal-form] .seal-button');
  const errorNode = document.querySelector('[data-seal-form] [data-seal-customer-portal-error]');
  const successNode = document.querySelector('[data-seal-form] [data-seal-customer-portal-success]');
  if(heading) heading.setAttribute('aria-level','1');
  if(emailInput){
    emailInput.type = 'email';
    emailInput.id = 'customer_email';
  }
  if(sendLinkBtn){
    sendLinkBtn.setAttribute('tabindex', 0);
    sendLinkBtn.setAttribute('role', 'button');
    sendLinkBtn.setAttribute('aria-label', 'send link to my email addres');
  }
  if(errorNode) errorNode.setAttribute('role', 'alert');
  if(successNode) successNode.setAttribute('role', 'alert');
}

jQuery(document).ready(function($){
  const ww = $(window).width();
  if(ww < 801){
    _theme.initSlickSlider($('.featured-promotions-hair-type-module .featured-promotions'),{
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 791,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2.5
          }
        }
      ]
  }) 
    _theme.initSlickSlider($('.shop-by-collection-wr .list-collections'),{
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 791,
          settings: {
            slidesToShow: 2.5,
            arrows: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2.5,
            arrows: true
          }
        }
      ]
    })
    _theme.initSlickSlider($('.shop-by-type-wr .featured-promotions'),{
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
        responsive: [
          {
            breakpoint: 798,
            settings: {
              slidesToShow: 2.5
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.5
            }
          }
        ]
  })
  }

  _theme.initSlickSlider($('.tab-slider > .one-whole > .product-list'),{
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: window.innerWidth < 991 ? false : false,
    rows:0,
    responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 2.5,
            arrows: true,
          }
        },
        {
          breakpoint: 490,
          settings: {
            slidesToShow: 1.5,
            arrows: true,
          }
        }
      ]
  });

  const complementaryProductInterval = setInterval(function(){
    if($('.complementary-products__slider').length > 0) {
      clearInterval(complementaryProductInterval);
      _theme.initSlickSlider($('.complementary-products__slider'),{
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: window.innerWidth < 991 ? false : true,
        rows:0,
        responsive: [
            {
              breakpoint: 798,
              settings: {
                slidesToShow: 2.5,
                arrows: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2.5,
                arrows: true,
              }
            }
          ]
      },function() {

        function updateMoney(priceEl) {
          if(!priceEl) return
          if(priceEl.closest('.complementary-product__price-wrapper').children.length>1)  {
            let price=priceEl.innerText
            let srText = priceEl.classList.contains('complementary-product__price-compare') ? 'Regular Price' : 'Sale Price';
            if(priceEl.classList.contains('complementary-product__price-compare')) srText = 'Regular Price';
            if(priceEl.closest('.complementary-product__price-compare')) srText = 'Regular Price';   
            priceEl.innerHTML = '<span class="visually-hidden">'+srText+' </span>'+ price ; 
          }
        } 
        const priceEls=document.querySelectorAll('.complementary-products span.money > span.money');
        if(priceEls.length) {
          for(let i=0; i< priceEls.length; i++) {
              updateMoney(priceEls[i]);    
          }
        }
      })
    }
  }, 1000);

  setTimeout(function(){
    if(complementaryProductInterval) clearInterval(complementaryProductInterval);
  }, 7000);



  const complementaryProductIntervalPdp = setInterval(function(){
    if($('.complementary-products__slider_pdp').length > 0) {
      if($('.complementary-products__slider_pdp .complementary-single-product').length > 3 ){
        clearInterval(complementaryProductIntervalPdp);
        _theme.initSlickSlider($('.complementary-products__slider_pdp'),{
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: window.innerWidth < 991 ? false : true,
          rows:0,
          responsive: [
              {
                breakpoint: 798,
                settings: {
                  slidesToShow: 2.5,
                  arrows: true,
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2.5,
                  arrows: true,
                }
              }
            ]
        },function() {
  
          function updateMoney(priceEl) {
            if(!priceEl) return
            if(priceEl.closest('.complementary-product__price-wrapper').children.length>1)  {
              let price=priceEl.innerText
              let srText = priceEl.classList.contains('complementary-product__price-compare') ? 'Regular Price' : 'Sale Price';
              if(priceEl.classList.contains('complementary-product__price-compare')) srText = 'Regular Price';
              if(priceEl.closest('.complementary-product__price-compare')) srText = 'Regular Price';   
              priceEl.innerHTML = '<span class="visually-hidden">'+srText+' </span>'+ price ; 
            }
          } 
          const priceEls=document.querySelectorAll('.complementary-products span.money > span.money');
          if(priceEls.length) {
            for(let i=0; i< priceEls.length; i++) {
                updateMoney(priceEls[i]);    
            }
          }
        })
      }
     
    }
  }, 1000);

  setTimeout(function(){
    if(complementaryProductIntervalPdp) clearInterval(complementaryProductIntervalPdp);
  }, 7000);



  _theme.initSlickSlider($('.js-product-slider .product-list'),{
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: window.innerWidth < 991 ? false : false,
    rows:0,
    responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 2.5,
            arrows: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5,
            arrows: true,
          }
        }
      ]
  });


  
  if($('body.page--page').length > 0){
    _theme.initSlickSlider($('.image-with-product-container .product-container.enable-slider'),{
      slidesToShow: 2.5,
      slidesToScroll: 1,
      infinite: false,
      rows:0,
      responsive: [
          {
            breakpoint: 798,
            settings: {
              slidesToShow: 2.5,
              arrows: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2.5,
              arrows: true,
            }
          }
        ]
    });
  }

  // related collection slick slider code starts here
  var numberOfCollectionList = $('.related-collection-item').length;
  var useSlick = numberOfCollectionList > 6;
  
  if (useSlick) {
    // slick slider with dots
    var slickSlider = $('#position-dots').slick({
      slidesToShow: 5.5,
      slidesToScroll: 3,
      infinite: window.innerWidth < 991 ? false : false,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4.5,
            arrows: false,
          }
        }
      ]
    });
  
    // slick slider with arrow
    var relatedslickSlider = $('#position-arrow').slick({
      slidesToShow: 5.5,
      slidesToScroll: 3,
      infinite: window.innerWidth < 991 ? false : false,
      prevArrow:'<button type="button" class="slick-prev" aria-label="Previous"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow:'<button type="button" class="slick-next" aria-label="Next"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4.5,
            arrows: true,
          }
        }
      ]
    });
  
    var totalSlides = slickSlider.slick('getSlick').slideCount;
    slickSlider.slick('slickSetOption', 'dots', totalSlides > 7, true);
    
    if (window.innerWidth <= 767) {
      slickSlider.slick('unslick');
      relatedslickSlider.slick('unslick');
    }
    $('.related-collection-container').addClass('relatedCollActive');
  } else {
    $('.related-collection-container').addClass('noSlick');
  }
  
  // related collection slick slider code ends here

  _theme.initSlickSlider($('.custom-testimonial-slider'),{
    centerMode: false,
    autoplay: true,
    centerPadding: '0px',
    slidesToShow: 3,
    arrows: true,
    dots: true,
    prevArrow:'<button type="button" class="slick-prev" aria-label="Prevoius"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow:'<button type="button" class="slick-next" aria-label="Next"><svg class="slick-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '120px',
          }
        },
        {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '80px',
              pauseOnHover:false,
              autoplaySpeed: 1500
            }
          },
          {
            breakpoint: 350,
            settings: {
              slidesToShow: 1,
              centerPadding: '30px',
              pauseOnHover:false,
              autoplaySpeed: 1500
            }
          },
      ]
  }, function(slick){
      const $parent = slick.$slider.parent();
      const $sliderInstance = $('.custom-testimonial-slider');
      _theme.initSliderPlayPause($parent, $sliderInstance, true,'Customer feedback slider');

      setTimeout(function() {
        let text=$('.custom-testimonial-slider').find('.slick-dots').find('li.slick-active').find('button').attr('aria-label');
        $('.custom-testimonial-slider').append('<span class="slide-count-slick">'+text+'</span>');
      },100)
      
    },function() {
      let text=$('.custom-testimonial-slider').find('.slick-dots').find('li.slick-active').find('button').attr('aria-label');
      $('.slide-count-slick').text(text);
    });


  _theme.initSlickSlider($('.blogs-wrapper'),{
    slidesToShow: 3,
    arrows: false,
    dots: false,
    responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 2,
            arrows: true,
            dots: true,
          }
        },
        {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              arrows: true,
              dots: true,
            }
        }
    ]
  }, function(slick){ 
    slick.$slider.find('.slick-dots li button').removeAttr('role');
    slick.$slider.find('.slick-dots button').each(function(i,elm){
      $(elm).attr('aria-label','blog '+ Number(i+1));
      if($(elm).parent().hasClass('slick-active')) { 
        $(elm).attr('aria-label','blog '+ Number(i+1)+' current item');  
      }
    });
    setTimeout(function(){
      slick.$slider.find('.slick-dots').removeAttr('role').find('li button').removeAttr('role');
      slick.$slider.find('.slick-dots button').removeAttr('tabindex')
      slick.$slider.find('.slick-dots button').each(function(i,elm){
        $(elm).attr('aria-label','blog '+ Number(i+1));
        if($(elm).parent().hasClass('slick-active')) { 
          $(elm).attr('aria-label','blog '+ Number(i+1)+' current item');  
        }
      });
      slick.$slider.find('.slick-dots button').removeAttr('tabindex');
    }, 500);
  }, function(slick){
    slick.$slider.find('.slick-dots').removeAttr('role').find('li button').removeAttr('role');
    slick.$slider.find('.slick-dots button').each(function(i,elm){
      $(elm).attr('aria-label','blog '+ Number(i+1));
      if($(elm).parent().hasClass('slick-active')) { 
        $(elm).attr('aria-label','blog '+ Number(i+1)+' current item');  
      }
    });
    slick.$slider.find('.slick-dots button').removeAttr('tabindex');
    setTimeout(function(){
      slick.$slider.find('.slick-dots').removeAttr('role').find('li button').removeAttr('role');
      slick.$slider.find('.slick-dots button').each(function(i,elm){
        $(elm).attr('aria-label','blog '+ Number(i+1));
        if($(elm).parent().hasClass('slick-active')) { 
          $(elm).attr('aria-label','blog '+ Number(i+1)+' current item');  
        }
      });
      slick.$slider.find('.slick-dots button').removeAttr('tabindex');
    }, 500);
  })

  if($('body').hasClass('index')) {
    var $collectionInputTabs = document.querySelectorAll('.tab-title-wrapper.automatic');
    for (var i = 0; i < $collectionInputTabs.length; i++) {
      new TabsAutomatic($collectionInputTabs[i]);
    }
    /*const $collectionInputTabs = $('body.index .tab-title-wrapper input[type="radio"]');
    $collectionInputTabs.on('change', function(evt) {
        const target = $(this).val();
        if(!target) return;
        $(".tab-title").removeClass("active");
        $(".tab-slider-sec").hide();
        $("#lable-"+target).addClass("active");
        $(".tab-products__panel-"+target).fadeIn();
        $(".tab-products__panel-"+target+' .tab-slider > .one-whole > .product-list').slick('refresh');
    });*/
  }

  var $globalTabs = document.querySelectorAll('.tabs-global-title-wrapper.automatic');
    for (var i = 0; i < $globalTabs.length; i++) {
      new TabsAutomatic($globalTabs[i]); 
    }

    var $SearchPageTab = document.querySelectorAll('.search-page-title-wrapper.automatic');
      for (var i = 0; i < $SearchPageTab.length; i++) {
        new TabsAutomatic($SearchPageTab[i]); 
      }
    
    if(window.innerWidth < 798) {
      var $headerSearchTab = document.querySelectorAll('.search-tab-title-wrapper.automatic');
      for (var i = 0; i < $headerSearchTab.length; i++) {
        new TabsAutomatic($headerSearchTab[i]); 
      }
    }

  // if($('.tabs-global').length > 0) {
  //   const $collectionInputTabs = $('.tabs-global-title-wrapper input[type="radio"]');
  //   $collectionInputTabs.on('change', function(evt) {
  //       const target = $(this).val();
  //       if(!target) return;
  //       $(".tabs-global-title").removeClass("active");
  //       $(".tabs-global__panel").hide();
  //       $("#lable-"+target).addClass("active");
  //       $(".tabs-global__panel-"+target).fadeIn();
  //   });
  // }

  $(document).on('keyup', '.tab-title', function(e) {
    if(e.which === 13) {
      $(this).trigger('click')
    }
  })

  $(document).on('click', '.product-list .column.thumbnail .product-wrap .product_gallery .gallery-cell', function(evt){
    evt.preventDefault();
    const url = $(this).closest('.column.thumbnail').data('url');
    if(url) window.location.href = url;
  });

  $(document).on("click", ".srch-icon-btn", function(){
      this.isMobile = window.innerWidth < 1080 ? true : false;
      if(this.isMobile){
        var final_top_pos = $('header.mobile_nav-fixed--true').height();
        if(window.innerWidth < 799) {
          $('.header-search-left').addClass('is-hidden');
        } else {
          $('.header-search-left').removeClass('is-hidden');
        }
      } else {
        if($('.main-nav__wrapper').hasClass('sticky_nav--stick')) {
          var final_top_pos = $('.main-nav__wrapper').height();
        } else {
          var final_top_pos = $("#site-header").height();
        }
        $('.header-search-left').removeClass('is-hidden');
      }
      $('.header-seach-wrap').css('top',final_top_pos+'px');
      $('body').toggleClass('search-active overflow-hidden');

      // console.log($(this).attr('aria-expanded'));
      if($(this).attr('aria-expanded') == 'false') {
        $(this).attr('aria-expanded','true');
        $('.header-search__input').focus();
      } else {
        $(this).attr('aria-expanded','false');
      }

      if(window.innerWidth < 1080) return;
      const headerNode = document.getElementById("site-header");
      const headerSearch = document.querySelector('.header-seach-wrap');
      if(!headerNode || !headerSearch) return;
      const headerHeight = headerNode.offsetHeight;
      if(!headerHeight) return;
      headerSearch.style.setProperty('--header-search-height', `calc(100vh - ${headerHeight}px)`);
  });

  $(document).on('keyup', '.search-container' ,function(e) {
    if(e.which === 27 ) {
      $(".search-ic-header .search-container").stop().slideUp();
      $('.search-ic-header .srch-icon-btn').attr('aria-expanded','false')
      $('.srch-icon-btn').focus(); 
    }
  }) 

  $(document).on('click', '.product-list .column.thumbnail .product-wrap .product_gallery .gallery-cell', function(evt){
    evt.preventDefault();
    const url = $(this).closest('.column.thumbnail').data('url');
    if(url) window.location.href = url;
  });
  // $(document).on('focusout', '.search-container input' ,function(e) {
  //   setTimeout(function() {
  //     $(".search-ic-header .search-container").stop().slideUp();
  //     $('.search-ic-header .srch-icon-btn').attr('aria-expanded','false')
  //   },400)
  // })  
});

window.addEventListener('DOMContentLoaded', () => {
  if($('body.product').length) _theme.ProductPage();
  _theme.Account();
  _theme.sealSubscriptionlogin();
});



// $('body').on('click','.minicart-close',function(){
//   $(".tos_warning.cart_content.animated.fadeIn.mini-cart").css("display", "none");
//   $("body").removeClass('mini-cart-open');
//   $(".wrapper-overlay").removeClass('active');
// })

// $('body').on('click','.mini_cart',function(){
//   $(".tos_warning.cart_content.animated.fadeIn.mini-cart").css("display", "block");
//   $("body").addClass('mini-cart-open');
//   $(".wrapper-overlay").addClass('active');
// })

// $(".minicart-close").click(function(){
//   $(".tos_warning.cart_content.animated.fadeIn.mini-cart").css("display", "none");
// });


$('body').on('click','.note-label-icon',function(){
  $(this).toggleClass('icon_active');
  $('textarea').toggle();
})


$('body').on('click','.seal-subscription-page',function(){
  $(".seal-floating-label label").css("top", "8%");
});

//
$("#tabpanel-product-description .rte h4").attr("aria-level","2");
$('#phone_inp').on('keydown',function(e) { 
  if(e.target.value.length < 1) {
    if(e.which===48) {
      e.preventDefault() 
    }
  }


  if(e.target.value.includes('+')) {
    if(e.which === 61 || e.which === 187 ) {
      e.preventDefault(); 
      return false;
    }
  }
  
  if(e.target.value.includes('x')) {
    if(e.which === 88) {
      e.preventDefault(); 
      return false;
    }
  } 

  const elm=e.target.value.split('')
  const checkDash=elm.filter(e=>e=='-')
  

  if(checkDash.length === 2) {
    if(e.which === 173 || e.which === 189 ) { 
      e.preventDefault();
      return false;
    }
  }
});
//
if (window.matchMedia('(max-width: 767px)').matches) {
  $(document).ready(function(){     
    $(document).on('click','.mobile-footer-menu-btn',function(){
        
        var currentContent = $(this).siblings('.toggle_content');
        if($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('.toggle_content').slideUp();
          $(this).attr('aria-expanded', 'false');
        } else {
          $('.mobile-footer-menu-btn').removeClass('active').attr('aria-expanded', 'false');
          $(this).addClass('active');
          $('.toggle_content').not(currentContent).slideUp();
          $(this).next().slideToggle( 'slow', function() {});
          $(this).attr('aria-expanded', 'true');
        }
    });
  });
}
var GiftCardSelector = setInterval(function () {
  if($('.single-option-selector').length > 0){
  $(".single-option-selector").attr("aria-label","Size");
  clearInterval(GiftCardSelector);
  };
  }, 1000);
  setTimeout(function() {
  clearInterval(GiftCardSelector);
  },10000);

$(document).ready(function(){
  var SortByText = setInterval(function () {
  $('#select2-sort-by-container').prepend('<span class="visually-hidden">Sort BY</span>')
  clearInterval(SortByText);
}, 1000);
  setTimeout(function() {
  clearInterval(SortByText);
  },10000);
})

$(document).ready(function() {
    $("a.testi-item-img").removeAttr("tabindex");       
});
if (window.matchMedia('(max-width: 767px)').matches) {
  $(document).ready(function () {
$('.account-sidebar .address .account-order').click(function() {
  $('.account-sidebar .address p.active').removeClass('active');
  $(this).toggleClass('active');
  $('body').find('.account-left').hide();
  $('body').find('.my-order').show();
  $('body').find('.account-title').hide();
});
$('.action_add').click(function() {
  $('.wrapper-overlay').addClass('active');
});
});
}

if (window.matchMedia('(min-width: 767px)').matches) {
$(document).ready(function () {
$('.action_add').click(function() {
  $('.wrapper-overlay').addClass('active');
});
$('.edit-address-action').click(function() {
  $('.wrapper-overlay').addClass('active');
});
});
}


$(document).ready(function () {
  $('.add-address-close-btn').click(function() {
    $('.wrapper-overlay').removeClass('active');
    $('.add_address').hide();
  });

  $('.my-order .address-back-btn a').click(function() {
    $('.my-order').hide();
    $('body').find('.account-left').show();
    $('body').find('.account-title').show();
  });

  $('.add-address-btn-cancle-btn a').click(function() {
    $('.wrapper-overlay').removeClass('active');
  });
  $('.address-back-btn a').click(function() {
    $('.wrapper-overlay').removeClass('active');
  });

  $('.action_link .global-button').on('click',function() {
    _theme.focusTrap($('#add_address'),function(){
      $('#address_first_name_new').focus();
    });   
  })
  $('.address_actions .global-button').on('click',function() {
    _theme.focusTrap($('.customer_address.edit_address'),function(){
      $('.address_form').focus();
    });   
  })

  setTimeout(function() {
  $('.seal-button').attr('role', 'button');
  $('.seal-button').attr('tabindex', '0');
}, 2000);

setTimeout(function() {
  if($('#customer_email').length && $('#customer_email').val().length <= 0){
    $(".seal-subscription-page .seal-floating-label label[data-seal-t='customrportalloginform_email_label']").css("top", "25%" );
  }
}, 1000);

});

$(document).keydown(function(event) { 
  if (event.keyCode == 27) { 
    $('.custome_esc_close').hide();
    $('.wrapper-overlay').removeClass('active');
  }
});

$(document).ready(function () {
  setTimeout(function() {
    $('.sticky_nav').attr("role","complementary");
    $('.sticky_nav').attr("aria-label","Sticky header");
    $('.sticky_nav .nav-desktop').attr("aria-label","Sticky navbar");
}, 1000);
// pdp click on star trigger to its description code starts here
$('body').on('click', '.product-main .bv_stars_component_container', function() {
  $('#product-tab-reviews').trigger('click');
});
// pdp click on star trigger to its description code ends here

var mobFilterHeight = $('.sort_filter_mobile').height();
$('.footer_credits').css('padding-bottom', mobFilterHeight+'px');

// blog third party url remove code starts here
$('.article_content .rte a[href="http://luvtobnatural.com/"]').css({'color' : 'black','pointer-events' : 'none'});
$('.article_content .rte a[href="https://tiffofalltrades.com/"] span').css({'color' : 'black','pointer-events' : 'none'});
$('.article_content .rte a[href="http://naturally-glam.com/"]').css({'color' : 'black','pointer-events' : 'none'});
$('.toggle_content ul li p a[href="https://www.morethanastrand.com/"]').attr('target','_blank');
// pdp tab changes starts here
$(".product-accordion-item button").click(function () {
  $(this).toggleClass("active").next(".rte").slideToggle().parent().siblings().find(".rte").slideUp().prev().removeClass("active");
});
// pdp tab changes ends here

var pdpImageHeight = $('.product .product_gallery .lightbox .image__container').height();
var pdpImageHeight = $('.complementary-products').height();
var salePromoHeight = $('.custom_grid').height();
$('.product .product_gallery .lightbox .image__container').css('min-height', pdpImageHeight+'px');
$('.complementary-products').css('min-height', pdpImageHeight+'px');
$('.sale_messageContainer').css('min-height', salePromoHeight+'px');
setTimeout(function(){
$("a.vdo.cboxElement img").each(function () {
  var img = $(this);
  img.attr("alt", '');
});
$("a.vdo.cboxElement").each(function () {
  var img = $(this);
  img.attr("aria-label", 'YouTube Video');
});
},1000)
});

_theme.initLineItemToolTip = function(){
  const lineItemToolTips = document.querySelectorAll('.line-item-property-tooltip .line-item-property-value-modal');
  if(lineItemToolTips.length === 0) return;

  const showToolTip = evt => {
    const tooltip = evt.target.querySelector('.line-item-property-value-modal') || evt.currentTarget;
    if(!tooltip) return;
    const wrapper = tooltip.closest('.mini-cart__item-title');
    const parentLineItem = tooltip.closest('.line-item-property-tooltip');
    if(!parentLineItem || !wrapper) return;
    tooltip.removeAttribute('style');
    
    const wrapperWidth = wrapper.offsetWidth;
    let tooltipWidth = tooltip.offsetWidth;
    tooltipWidth = wrapperWidth === tooltipWidth ? tooltipWidth += 12 : tooltipWidth;
    const props = tooltip.getBoundingClientRect();
    const diff = tooltipWidth - props.width;
    if(diff > 0){
      tooltip.style.minWidth = `${tooltipWidth}px`;
      tooltip.style.left = `-${diff}px`;
    }

    if(props.top < 95){
      tooltip.style.bottom = 'auto';
      if(props.height > 0) tooltip.style.top = `${Math.ceil(props.height) + 8}px`;
    }
    parentLineItem.classList.add('active');
  }

  const hideToolTip = evt => {
    const target = evt.relatedTarget || evt.target;
    const activeLineItem =  document.querySelector('.line-item-property-tooltip.active');
    if(!activeLineItem || activeLineItem.contains(target)) return;
    activeLineItem.classList.remove('active');
  }

  lineItemToolTips.forEach(tooltip => {
    const parentLineItem = tooltip.closest('.line-item-property-tooltip');
    if(!parentLineItem) return;
    
    parentLineItem.removeEventListener('mouseover', showToolTip);
    parentLineItem.removeEventListener('mouseout', hideToolTip);
    parentLineItem.addEventListener('mouseover', showToolTip);
    parentLineItem.addEventListener('mouseout', hideToolTip);
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  _theme.initLineItemToolTip();
});

// home_page_banners_promo_blocks

$(".accord_btn a").click(function () {
  $(".accord_btn").toggleClass("active").next(".accord_btn_sbb").slideToggle().parent().siblings().find(".accord_btn_sbb").slideUp().prev().removeClass("active");
});


// custom cookies for US starts here 
$(document).ready(function () {
  // 
  $(".prefrence-cookies").click(function () {
    $(".cookies-popup-container").css("display", "block");
    $('.wrapper-overlay').addClass('active');
    $('body').addClass('cookies');
  });
  $(".cookies-popup-container .close-btn").click(function () {
    $(".cookies-popup-container").css("display", "none");
    $('.wrapper-overlay').removeClass('active');
    $('body.index').removeClass('cookies');
  });
  $(".cookies-glob-btn").click(function () {
    $('.close-btn').trigger('click');
    $('.cookies-container').css("display", "none");
  });
  $(".cookies-decline-btn").click(function () {
    $('.close-btn').trigger('click');
    $('.cookies-container').css("display", "none");
  });

  $(document).on('change', '.cookies-pref-input input:checkbox', function () {
    // Check how many input checked
    const checked = $(".cookies-pref-input input:checkbox:checked").length;
    if (checked > 1) {
      $('.cookies-save-header').addClass("checked");
    } else {
      $('.cookies-save-header').removeClass("checked");
    }
  });
  //
});
$(document).ready(function () {
  $(".cookies-glob-btn").click(function () {
    // Save on LocalStorage
    window.localStorage.setItem('accept_cookies', true)
    $('.cookies-container').removeClass('not_clicked');
    $('.cookies-container').addClass('buttonClicked');
    $('.cookies-container').hide();
  });
  if (window.localStorage.getItem('accept_cookies')) {
    $('.cookies-container').addClass('buttonClicked');
  }

  $(".cookies-decline-btn").click(function () {
    // Save on LocalStorage
    window.localStorage.setItem('accept_cookies', false)
    $('.cookies-container').removeClass('not_clicked');
    $('.cookies-container').addClass('buttonClicked');
    $('.cookies-container').hide();
  });
  if (window.localStorage.getItem('accept_cookies')) {
    $('.cookies-container').addClass('buttonClicked');
  }
});
// custom cookies for us ends here

//Select product layout for collection code starts here
$(document).ready(function () {
  $('.one_row, .row_two').on('click', function(){
    if ($(this).hasClass('one_row')) {
  $(this).addClass('singleGrid');
  $('body').addClass('changeGrid');
  $('.two_row').removeClass('doubleGrid');
    } else {
  $('.two_row').addClass('doubleGrid')
  $('body').removeClass('changeGrid');
  $('.one_row').removeClass('singleGrid');
    }
  });
});
//Select product layout for collection code ends here

// ADA fixes for store locater page starts here
$(document).ready(function(){
  if (window.location.pathname === "/pages/stores") {
      let interval = setInterval(function(){
          if ($('.mapboxgl-ctrl-attrib-inner').length) {
              $('.mapboxgl-ctrl-attrib-inner').removeAttr('role');
              clearInterval(interval);
          }
      }, 1000);
  }
});
// ADA fixes for store locater page ends here

// afterpay ada code starts here
$(document).ready(function() {
  if (window.location.href.indexOf("/products") !== -1) {
  let interval = setInterval(function(){
      var squarePlacement = document.querySelector('square-placement[data-payment-amount-is-bold="true"]');
      if (squarePlacement && squarePlacement.shadowRoot) {
          var afterpayLogoLink = squarePlacement.shadowRoot.querySelector('.afterpay-logo-link');
          if (afterpayLogoLink) {
              clearInterval(interval);
              afterpayLogoLink.addEventListener('click', function() {
                  var afterpayModal = document.querySelectorAll("afterpay-modal")[0];
                  if (afterpayModal && afterpayModal.shadowRoot) {
                      var afterpayModalElement = afterpayModal.shadowRoot.querySelector("#afterpay-modal");
                      if (afterpayModalElement) {
                          afterpayModalElement.focus();
                      }
                  }
              });
          }
      }
  }, 2000);
}
});
// afterpay ada code ends here


// Slider Focus ADA code fixes starts here
$(document).ready(function() {
var sliderFocusAda = setInterval(function() {
  $('.product-list .one-fourth[aria-hidden="true"]').each(function() {
      var productDetails = $(this).find('[data-bv-show="inline_rating"] a').eq(0);
      if (productDetails.length && !productDetails.is('[tabindex="-1"]')) {
          productDetails.attr("tabindex", '-1');
          clearInterval(sliderFocusAda);
      }
  });
}, 2000);
});
// Slider Focus ADA code ends here

// qty limit code starts here
function updateCartTestAttributes(cartData) {
  const cartTests = document.querySelectorAll('.cart-test');
  cartTests.forEach(cartTest => {
    const variantId = cartTest.getAttribute('data-variant-id');
    const cartItemData = cartData.items.find(item => item.variant_id === parseInt(variantId));
    if (cartItemData) {
      const quantity = cartItemData.quantity;
      cartTest.setAttribute('data-cart-quantity', quantity.toString());

      if (quantity > 9) {
        cartTest.setAttribute('disabled', true);
      } else {
        cartTest.removeAttribute('disabled');
      }
    }
  });
}

// Function to fetch cart data and update cart-test attributes
function updateCartTest() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(cartData => {
      // console.log('cartData', cartData);
      updateCartTestAttributes(cartData);
    })
    .catch(error => {
      // console.error('Error fetching cart data:', error);
    });
}


document.addEventListener('DOMContentLoaded', () => {
  updateCartTest();
  setTimeout(updateCartTest());
  console.log('testcartdata', updateCartTest())
});

const cartTestObserver = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.target.classList.contains('cart-test')) {
      updateCartTest();
    }
  });
});

const cartTestContainer = document.querySelector('.cart-test-container');
if (cartTestContainer) {
  cartTestObserver.observe(cartTestContainer, { subtree: true, childList: true });
}


function checkAndUpdate() {
  var selectBox = document.getElementsByClassName("qtynumber");
  var selectedValue = parseInt(selectBox.value);
  if (selectedValue > 10) {
    selectBox.value = "10";
    alert("Maximum value cannot exceed 10.");
  }
}


$(document).ready(function(){
if (window.location.href.indexOf("/products") !== -1) {
$('select#purchase-details__quantity-select').on('change', function (e) {
  var valueSelected = parseInt(this.value);
  // console.log('Selected value:', valueSelected);

  var itemInCurrentCart = parseInt($('#cart-real-item').attr('item-in-cart'));
  // console.log('Item in Current Cart:', itemInCurrentCart);

  var total = valueSelected + itemInCurrentCart;
  // console.log('Total:', total);

  if (total > 10) {
    // console.log('Total greater than 10:', total);
    $(this).val(10 - itemInCurrentCart);
$('.acced-limit-message').addClass('active');
  } else {
    // console.log('Total less than or equal to 10:', total);
    $('.acced-limit-message').removeClass('active');
  }
});

function updateDisabledOptions(selectElement) {
  const itemInCart = parseInt(selectElement.getAttribute('item-in-cart'));
  const options = selectElement.querySelectorAll('option');
  let hasDisabledOption = false;
  options.forEach(option => {
      const value = parseInt(option.value);
      option.disabled = (value + itemInCart > 10);
      if (option.disabled) {
          hasDisabledOption = true;
      }
  });
  if (hasDisabledOption) {
  } else {
      $('.acced-limit-message').removeClass('active');
  }
}

// Get the select element
const selectElement = document.getElementById('purchase-details__quantity-select');
updateDisabledOptions(selectElement);
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'item-in-cart') {
          updateDisabledOptions(selectElement);
      }
  });
});
const config = { attributes: true };
observer.observe(selectElement, config);
}
})
function checkForNostoScript() {
  var script = document.querySelector('script[src="//connect.nosto.com/script/shopify/nosto.js?merchant=shopify-7638199"]');
  if (script) {
      observer.disconnect();
      updateCartTest();
  }
}

if (window.location.href.includes('page')) {
  var $table = $('body.page--page table');
  if ($table.length > 0) {
      console.log('Table found');
      var $firstTableRow = $table.find('tbody tr').first();
      if ($firstTableRow.length > 0) {
          console.log('First <tr> element found:', $firstTableRow[0].outerHTML);
          $firstTableRow.find('td').each(function() {
              var $td = $(this);
              var $th = $('<th>').html($td.html());
              $td.replaceWith($th);
          });
          // console.log('Updated <tr> element:', $firstTableRow[0].outerHTML);
      } else {
          // console.log('No <tr> elements found in the table');
      }
  } else {
      // console.log('No table found in the specified selector');
  }
}

$(document).ready(function(){
$('.lightbox').on('click', function() {
  alert('model opened');
  
  setTimeout(function() {
    $('button.fancybox-button.fancybox-close-small').focus();
    
    $('.fancybox-image-wrap a').each(function() {
      $(this).attr('tabindex', '0');
    });
  }, 1000);
});
})

$(document).ready(function() {
    $('.flickity-page-dots').find('.dot').each(function(index) {
      var totalDots = $('.flickity-page-dots .dot').length;
      $(this).attr('aria-label', `Slide ${index + 1} of ${totalDots}`);
      $(this).attr('role', 'button');
      $(this).attr('tabindex', '0');
    });
    function updateAriaCurrent() {
      var $dots = $('.flickity-page-dots .dot');
      $dots.each(function() {
        var isCurrent = $(this).hasClass('is-selected');
        $(this).attr('aria-current', isCurrent ? 'true' : 'false');
      });
    }
    updateAriaCurrent();
    $(document).on('change.flickity', function() {
      updateAriaCurrent();
    });
  
});
const modal = document.getElementById('filter-model');
const firstFocusableElement = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

modal.addEventListener('shown.bs.modal', () => {
  firstFocusableElement.focus();
});




